'use client';

import { c as _c } from "react/compiler-runtime";
import { type Choice, ChoiceList, Heading } from '@jaaq/hub-ui';
import { Puzzle, TrendingUp, Zap } from 'lucide-react';
import type { ReactElement } from 'react';
import { OnboardingShell } from '#components/onboarding-shell';
import type { IconKey } from '#lib/content/types';
import { useOnboardingContent, useOnboardingState } from '#lib/onboarding-provider';
import type { Priority } from '#lib/steps/state';
export const PriorityStep = () => {
  const $ = _c(17);
  const {
    onboardingState,
    patch,
    goNext
  } = useOnboardingState();
  const {
    priority
  } = useOnboardingContent();
  const {
    priority: selectedPriority
  } = onboardingState;
  let t0;
  if ($[0] !== priority.choices) {
    t0 = priority.choices.map(_temp);
    $[0] = priority.choices;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const choices = t0;
  const t1 = Boolean(selectedPriority);
  let t2;
  if ($[2] !== priority.heading) {
    t2 = <Heading level={1} variant="display" tone="inverse">{priority.heading}</Heading>;
    $[2] = priority.heading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== patch) {
    t3 = id_0 => patch({
      priority: id_0
    });
    $[4] = patch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== selectedPriority || $[7] !== t3) {
    t4 = {
      selectedId: selectedPriority,
      onSelect: t3
    };
    $[6] = selectedPriority;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== choices || $[10] !== t4) {
    t5 = <ChoiceList choices={choices} selection={t4} />;
    $[9] = choices;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== goNext || $[13] !== t1 || $[14] !== t2 || $[15] !== t5) {
    t6 = <OnboardingShell canContinue={t1} onContinue={goNext}>{t2}{t5}</OnboardingShell>;
    $[12] = goNext;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};

/* ----- icon registry ----- */

type IconProps = {
  name: IconKey;
};
const Icon = t0 => {
  const $ = _c(3);
  const {
    name
  } = t0;
  switch (name) {
    case "zap":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Zap className="size-6" />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "puzzle":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Puzzle className="size-6" />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "trending-up":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <TrendingUp className="size-6" />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
};
function _temp(t0) {
  const {
    id,
    title,
    description,
    iconKey
  } = t0;
  return {
    id,
    title,
    description,
    icon: <Icon name={iconKey} />
  };
}